import { Badge } from "@components/shadcn-ui/badge";
import { Button } from "@components/shadcn-ui/button";
import { Card } from "@components/shadcn-ui/card";
import { encodeURIComponent } from "@lib/utils";
import { Link } from "react-router-dom";
import {
  APPLICATION_STATUS,
  getProductTypeByValue,
  getStatusColor,
} from "./config";
import PermissionWrapper from "features/Permission/PermissionWrapper";
import { Action, ApplicationState } from "features/Permission/types";
import { FilePenLine } from "lucide-react";
import { ActionButtonWithPersmission } from "./components/ActionButtonWithPersmission";

interface MobileApplicationCardProps {
  applications: {
    product: string;
    id: string;
    createdOn: string;
    customerName: string;
    state: ApplicationState;
    createdTime: string;
  }[];
}

export const MobileApplicationCard = ({
  applications,
}: MobileApplicationCardProps) => {
  return (
    <div className="flex flex-col gap-1 md:hidden overflow-auto">
      {applications.map((app, index) => (
        <Card key={index} className="flex flex-col gap-0 p-4">
          <div className="mb-2 flex justify-between items-center">
            <p className="text-md">
              <div className="flex items-center gap-2">
                <span className="text-md font-semibold">Status: </span>
                <Badge
                  className={`rounded-sm font-normal py-0 px-3 ${getStatusColor(
                    app.state
                  )}`}
                >
                  {
                    APPLICATION_STATUS[
                      app.state as keyof typeof APPLICATION_STATUS
                    ]
                  }
                </Badge>
              </div>
              <div className="">
                <span className="text-md font-semibold">App id: </span>
                <span className="text-sm font-semibol text-gray-500">
                  {app.id}
                </span>
              </div>
              <div>
                <span className="text-md font-semibold"> Created On: </span>
                <span className="text-sm font-semibol text-gray-500">
                  {/* Create a utils function Temporary */}
                  {new Date(app.createdTime).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}{" "}
                  at{" "}
                  {new Date(app.createdTime).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })}
                </span>
              </div>
              <div className="">
                <div className="">
                  <span className="text-md font-semibold">Product type: </span>
                  <span className="text-sm font-semibol text-gray-500">
                    {getProductTypeByValue(app.product)}
                  </span>
                </div>
                <span className="text-md font-semibold">Customer Name: </span>
                <span className="text-sm font-semibol text-gray-500">
                  {app.customerName}
                </span>
              </div>
            </p>
          </div>
          <div className="flex gap-2">
            <ActionButtonWithPersmission app={app} />
          </div>
        </Card>
      ))}
    </div>
  );
};
